import { SellerCenterSSOApiClient } from '@/apis';
import TokenService from '@/services/TokenService';

export default {
  async generateVerificationToken () {
    const token = await SellerCenterSSOApiClient.post('generate-verification-token', {
      refreshToken: TokenService.getRefreshToken(),
    }, { hideSpinner: true });

    return token;
  },
  getRedirectUrl (singleUseToken) {
    const params = {
      ChannelId: 'e4b2b2e2-aaeb-11ea-bb37-0242ac130002',
      platform: 'Web',
      sid: TokenService.getRefreshToken(),
      pid: TokenService.getToken(),
      singleUseToken,
    };
    const queryString = Object.keys(params).reduce((acc, key, index) => {
      return `${acc}${index > 0 ? '' +
        '&' : ''}${key}=${params[key]}`;
    }, '?');

    return `${process.env.VUE_APP_LIVE_CHAT_URL}${queryString}`;
  },
};
